import React from 'react'

import { Col, Row } from '../../../../../1stlog-ui/src/components/Bootstrap'
import OrderEntryCard, {
  IOrderEntryCardProps,
} from '../../components/OrderEntryCard'
import { MaxColisValidation } from './MaxColisValidation'
import Overview from './Overview'
import ShipmentServices from './ShipmentServices'

const Shipment = (
  props: Omit<IOrderEntryCardProps, 'title' | 'children'>,
): React.ReactElement => {
  return (
    <OrderEntryCard {...props} title={i18n.t('shipment', 'Sendung')}>
      <Row>
        <Col>
          <MaxColisValidation />
          <Overview />
          <ShipmentServices />
        </Col>
      </Row>
    </OrderEntryCard>
  )
}

export default Shipment
